<template>
  <div class="binItem model">
    <div class="title">添加仪器</div>
    <div class="binItem-list">
      <div class="search">
        <el-input size="small" maxlength="100"  v-model="search" suffix-icon="el-icon-search" placeholder="请输入仪器名称或者仪器编号检索"></el-input>
      </div>
      <div class="yq-list bar" id="viewBox" ref="viewBox">
        <!-- <template v-for="item,index in 20">
          <div class="list-item" :key="index">{{item}}</div>
        </template> -->
        <template v-for="(item, index) in InstrumentList">
          <div class="list-item" :key="index">
            <div class="cheeke">
              <el-checkbox v-model="item.checked" @change="
                  (value) => {
                    changeValue(value, item);
                  }
                "></el-checkbox>
            </div>
            <div class="name">{{ item.instrumentName }}</div>
            <div class="bianhao">{{ item.serialNumber }}</div>
          </div>
        </template>
        <p class="foter" v-if="!noMore">加载中···</p>
        <p class="foter" v-else>暂无更多数据···</p>
      </div>
    </div>
    <div class="footer">
      <div class="my-buttom select-buttom" @click="notarize">确认</div>
      <div class="my-buttom" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
import { getFreeInsList1 } from "@/api/depotApi.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      REQUIRE: true,
      InstrumentList: [],
      checkList: [], //选中的仪器
      search: "",
      deptId: "", //单位
      currentPage: 1,
      pageSize: 10,
      total: 0, //总数
      box: "", //元素
    };
  },
  created() {
    this.deptId = this.$store.state.user.userInfo.deptId;
    this.fetchData();
  },
  mounted() {
    this.box = this.$refs.viewBox;
    //添加滚动事件，检测滚动到页面底部
    this.box.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState(["depot"]),
    yqVal() {
      return 1;
    },
    DepotId() {
      return this.depot.selectWarehouse;
    },
    noMore() {
      return this.InstrumentList.length >= this.total;
    },
  },
  methods: {
    //获取数据
    fetchData(val) {
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        deviceType: 1,
        deptId: this.deptId, //单位
        depotId: this.DepotId, //仓库
        ...val,
      };
      getFreeInsList1(params).then((res) => {
        if (res.code == 200 && res.data) {
          let arr = res.data.records;
          this.checkList.forEach((item, index) => {
            for (var k in arr) {
              if (arr[k].id == item.id) {
                arr[k].checked = true;
                return;
              }
            }
          });
          this.total = res.data.total;
          this.InstrumentList = [...this.InstrumentList, ...res.data.records];
        }
      });
    },
    //选中数据
    changeValue(value, index) {
      if (value) {
        this.checkList.push(index);
      } else {
        this.checkList.splice(
          this.checkList.findIndex((item) => item.id === index.id),
          1
        );
      }
    },
    notarize() {
      this.$emit("notarize", "true", this.checkList);
    },
    cancel() {
      this.$emit("notarize", "false");
    },
    handleScroll() {
      // 滚动到页面底部时，请求前一天的文章内容
      var scrollTop = this.box.scrollTop;
      var windowHeitht = this.box.clientHeight;
      var scrollHeight = this.box.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop + windowHeitht == scrollHeight) {
        if (!this.noMore) {
          this.currentPage++;
          this.fetchData();
        } else {
          return;
        }
      }
    },
  },
  watch: {
    search() {
      delay(() => {
        this.currentPage = 1;
        this.InstrumentList = [];
        this.fetchData({ searchInfo: this.search });
      }, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.binItem {
  width: 100%;
  height: 426px;
  color: #74c8fe;
  .title {
    text-align: center;
    height: 27px;
    line-height: 27px;
    font-size: 28px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #74c8fe;
  }
  .binItem-list {
    margin: auto;
    margin-top: 20px;
    width: 349px;
    height: 330px;
    .search {
      margin: 10px;
    }
    .yq-list {
      height: 276px;
      border: 2px solid #0288e1;
      border-radius: 4px;
      box-shadow: 0 0 30px #046ab3 inset;
      padding: 4px 10px;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      .list-item {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;

        .cheeke {
          width: 10%;
        }
        .name {
          width: 50%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .bianhao {
          width: 40%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .foter {
        text-align: center;
      }
    }
  }
  .cheeke /deep/ .el-checkbox__inner {
    border: 1px solid #0288e1;
    width: 18px;
    height: 18px;
    background: #083d77;
  }
  .cheeke /deep/ .el-checkbox__inner::after {
    border: 1px solid #0288e1;
    border-left: 0;
    border-top: 0;
    height: 8px;
    left: 6px;
    top: 2px;
  }
  .footer {
    margin: 10px 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/yqz/binItem.vue